import { useEffect, useState } from "react";
import addicon from '../images/additem.png';
import img1 from '../images/resourceicon.png';
import axios from "axios";
import deleteIcon from '../images/deleteicon.png';
import editIcon from '../images/editicon.png';
import viewIcon from '../images/viewicon.png';
import sortIcon from '../images/arrow.png';
import { data } from "react-router";
import noimage from '../images/noimage.jpeg';
import loadIcon from '../images/loader2.webp';
import { connect } from "react-redux";
const Resources=({commonData})=>
{
    const [show,setShow]=useState(false);
    const [progress,setProgress]=useState(false);
    const [msg,setMsg]=useState("");
    const [resourcedata,setResourceData]=useState([]);
    const [dataToDisplay,setDataToDisplay]=useState([]);
    const [pageData,setPageData]=useState([]);
    const [formData,setFormData]=useState({id:"",facilityid:"",abbr:"",name:"",description:"",ismeetingroom:"",rtype:"",photo1:"",photo2:"",photo3:""});
    const [sortOrder,setsortOrder]=useState(1);
    const [page,setPage]=useState(1);
    const [pageSize,setPageSize]=useState(15);
    const [totalPage,setTotalPage]=useState(0);
    const [facilities,setFacilities]=useState([{facilityid:commonData.facilityid,facilityname:commonData.facilityname}]);    
    const apiClient = axios.create({
                baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer '+localStorage.getItem("token")
                }
            });  
    const columns = [       
        { name: "Facilities", key: "facilityname", sortable: true},
        { name: "Abbreviation", key: "abbr", sortable: true },        
        { name: "Category", key: "name", sortable: true },
        { name: "Resource Type", key: "rtype", sortable: true },
        { name: "Image 1", key: "photo1", sortable: false},      
        { name: "Image 2", key: "photo2", sortable: false},
        { name: "Image 3", key: "photo3", sortable: false},                        
    ];    
    async function loadResources()
    {
        setProgress(true);
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/Resource/GetAllResources").then(res=>
        {
            if(res.status==200)
            {
                setResourceData(res.data.data);
                setDataToDisplay(res.data.data);
                setPageData(res.data.data.slice(0,pageSize));                
                setTotalPage(Math.ceil(res.data.data.length/pageSize));                  
            }
        });                
        setProgress(false);
    }
    function searchData(event)
    {
        if(event.target.id=="searchText")
        {
            if(event.target.value.length>3)
            {
                let searchResult=resourcedata.filter((e)=>e.facilityname.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.abbr.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.name.toLowerCase().indexOf(event.target.value.toLowerCase())>=0  || e.rtype.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 );
                setDataToDisplay(searchResult);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay(resourcedata);                
                setPageData(resourcedata.slice(0,pageSize));
            }
            setPage(1);
        }
        if(event.target.id=="searchFacility")
        {
            if(event.target.value!="Facility")
            {
                let searchResult=resourcedata.filter((e)=>e.facilityname==event.target.value);
                setDataToDisplay([...searchResult]);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay([...resourcedata]);
                setPageData(resourcedata.slice(0,pageSize));
            }
            setPage(1);
        }           
    }
    function readFileData(file)
    {
        const reader = new FileReader();
        reader.onload = (e) =>
         {
            const content = e.target.result;
            //setFileContent(content);
            //console.log("File content:", content);
        };
        // Choose how to read the file:
        // reader.readAsText(file);        // For text, JSON, CSV, etc.
        // reader.readAsDataURL(file);    // For images, to generate a preview URL
        reader.readAsText(file); // Example: Reading as text
    }
    
    function checkAbbr(event)
    {
        if(formData.facilityid=="0" || formData.facilityid=="")
        {
            alert("Select Facility!!!!");
            return;
        }
        if(event.target.value.trim()!="" && formData.facilityid!="0")
        {
            let data=resourcedata.find((e)=>e.facilityid==formData.facilityid && e.abbr.toUpperCase()==event.target.value.trim().toUpperCase());
            if(data)
            {
                setFormData({...formData,abbr:""});
                alert("This Abbreviation Already Exists in Selected Facility");                                
            }
        }
    }
    function sortData(colname)
    {
        let arr=[...dataToDisplay];
        arr.sort((e1,e2)=>
        {
            let x=e1[colname].trim().toLowerCase()>e2[colname].trim().toLowerCase()?1:-1;
            x=x*sortOrder;
            setsortOrder(sortOrder*-1);
            return x;
        }
        );                                    
        setDataToDisplay(arr);                        
        setPageData(arr.slice(0,pageSize));
        setPage(1);                
    }
    function showPage(pagenumber)
    {
        let adata=dataToDisplay.slice((pagenumber-1)*pageSize,(pagenumber)*pageSize);
        setPageData(adata);
        setPage(pagenumber);
    }
    function showPrev(event)
    {
        let p=page;
        if(page>1) p--;        
        showPage(p);
    }
    function showNext(event)
    {
        let p=page;
        if(page<totalPage) p++;        
        showPage(p);
    }
    useEffect(()=>{
        loadResources();        
    },[]);
    return(
        <div>
            <div className="p-2 d-flex">
                <div className="me-2"><input type="text" id="searchText" style={{fontSize:'12px'}} onChange={searchData} placeholder="Search" className="form-control" /></div>
                <div className="me-2">                    
                </div>                                
            </div>
            <div style={{borderRadius:'5px 5px 0px 0px',backgroundColor:'#ffccdd',padding:'5px',fontWeight:'bold'}}>Resources</div>            
            <div style={{overflow:"auto",fontSize:'12px'}}>
                <table className="table table-striped table-bordered">
                    <thead>
                        <tr className="table-primary">
                            <th>S.No.</th>
                            {columns.map((e,i)=>                            
                                <th key={`fac-${i}`} >{e.name} {e.sortable?(<img src={sortIcon} onClick={()=>{sortData(e.key)}} style={{width:'10px',cursor:'pointer'}}  alt=""/>):(<></>)}</th>                            
                            )}                                                        
                        </tr>
                    </thead>
                    <tbody>
                        {pageData.map((e,i)=>
                            <tr key={`fac-${i}`}>
                                <td>{(page-1)*pageSize+i+1}</td>
                                {columns.map((ee,ii)=>                            
                                    <td key={ii}>{(ee.key=="photo1" || ee.key=="photo2" || ee.key=="photo3")?(<img src={e[ee.key]==""?noimage:e[ee.key]} width="30px" alt="" />):e[ee.key]}</td>                            
                                )}                                                                
                            </tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr className="table-primary">
                            <th colSpan="4"><input type="button" onClick={showPrev} value="<<<" className="btn btn-success btn-sm" /></th>
                            <th colSpan="4" className="text-center"></th>
                            <th colSpan="4" className="text-end"><input type="button" value=">>>" onClick={showNext} className="btn btn-success btn-sm" /></th>
                        </tr>
                        <tr className="table-primary">
                            <th colSpan="12">Total {dataToDisplay.length} Entries</th>                        
                        </tr>
                    </tfoot>
                </table>
            </div>               
                {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">                                                                                                                                                
                                    <img src={loadIcon} alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>                                                            
                        </div>
                    </div>
                )}
        </div>
    );
}
const connectToStore=(state)=>({commonData:state});
export default connect(connectToStore)(Resources);